<template>
    <products-carousel-section
        class="grocery-carousel-section-module"
        :title="attributes.groceryCarousel_title"
        :slides="formattedSlides"
        :button-text="attributes.groceryCarousel_button_text"
        :button-link="buttonLink"
        :show-navigation-buttons="attributes.groceryCarousel_show_navigation_buttons"
    />
</template>

<script>
    import ProductsCarouselSection from '../../../organisms/ProductsCarouselSection/ProductsCarouselSection';
    import { formatGrocerySlides } from '../../../../utils/formatters/format-carousel-slide-data';

    export default {
        name: 'grocery-carousel-section-module',

        components: { ProductsCarouselSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Safely return the button link.
             *
             * @returns {string}
             */
            buttonLink() {
                return this.attributes.groceryCarousel_button_link
                    ?.uri;
            },

            /**
             * Format api data for the OurMenuCarousel component.
             *
             * @returns {Array}
             */
            formattedSlides() {
                return formatGrocerySlides(this, this.attributes.grocery_products);
            },
        },
    };
</script>
